<template>
    <template v-if="!loading && !error && found > 0">
        <div class="container-fluid item-lists-type-6" :class="{'list-simple': simple}">
            <div class="container">
                <CompaniesListItem
                    v-for="(company, index) in displayedCompanies"
                    :key="company.id"
                    :company="company"
                    :simple="simple"
                    :class="{ 'active': isCurrentCompany(company) }"
                    :ref="`company-item-${index}`"
                />
            </div>
        </div>
    </template>
    <NoResultsSection
        v-else-if="!loading && !error"
        :message="mode === 'prospects' ? hasDefaultProspectsOptions ? 'views.prospects.no_results' : 'views.prospects.no_results_filter' : 'views.companies.no_results'"
    />
    <ErrorSection v-else-if="error" :error="error" />
    <LoadingSection v-else />
</template>

<script>
    import { mapState } from 'pinia';
    import { useCompaniesStore } from '@/stores/companies';
    import CompaniesListItem from '@/components/account/companies/CompaniesListItem';
    import ErrorSection from '@/components/sections/ErrorSection';
    import LoadingSection from '@/components/sections/LoadingSection';
    import NoResultsSection from '@/components/sections/NoResultsSection';

    export default {
        name: 'CompaniesList',
        components: {
            CompaniesListItem,
            ErrorSection,
            LoadingSection,
            NoResultsSection
        },
        props: {
            simple: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                displayedCompanies: []
            };
        },
        computed: {
            ...mapState(useCompaniesStore, ['mode', 'companies', 'loading', 'error', 'found', 'total', 'options', 'prospectOptions', 'currentCompanyIndex', 'hasDefaultProspectsOptions']),
        },
        methods: {
            isCurrentCompany(company) {
                return this.currentCompanyIndex !== null && 
                       this.companies?.length > 0 && 
                       this.companies[this.currentCompanyIndex]?.id === company.id;
            },
            findScrollableParent(node) {
                if (node == null) {
                    return document.documentElement;
                }
            
                if (node.scrollHeight > node.clientHeight) {
                    return node;
                } else {
                    return this.findScrollableParent(node.parentNode);
                }
            },
            scrollToActiveCompany() {
                this.$nextTick(() => {
                    const activeCompanyRef = this.$refs[`company-item-${this.currentCompanyIndex}`];
                    if (activeCompanyRef && activeCompanyRef[0]) {
                        activeCompanyRef[0].$el.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                });
            }
        },
        watch: {
            companies: {
                handler(newCompanies, oldCompanies) {
                    const newCompaniesIds = newCompanies.map(company => company.id);
                    const oldCompaniesIds = oldCompanies.map(company => company.id);
                    const sameIds = newCompaniesIds.length === oldCompaniesIds.length && newCompaniesIds.every((id, index) => id === oldCompaniesIds[index]);
                    if(sameIds) {
                        if (this.currentCompanyIndex !== null) {
                            this.scrollToActiveCompany();
                        }
                        return;
                    }

                    this.displayedCompanies = [];

                    if(newCompanies.length < 1) {
                        return;
                    }

                    newCompanies.forEach((company, index) => {
                        setTimeout(() => {
                            this.displayedCompanies.push(company);
                        }, index * 50 < 500 ? index * 50 : 500);
                    });

                    if (this.currentCompanyIndex !== null) {
                        setTimeout(() => {
                            this.scrollToActiveCompany();
                        }, Math.min(newCompanies.length * 50, 500) + 100);
                    }
                },
                deep: true
            },
            currentCompanyIndex(newIndex) {
                if (newIndex !== null && this.companies?.length > 0 && this.companies[newIndex]) {
                    this.scrollToActiveCompany();
                }
            }
        },
        mounted() {
            this.displayedCompanies = this.companies;
            this.scrollToActiveCompany();
        }
    }
</script>